<div class="ui basic segment" [class.loading]="isLoading">
    <app-job-posting-create-interview
        [interview]="interview"
        [jobPosting]="jobPosting"
        (saveInterview)="onSave()"
    ></app-job-posting-create-interview>
</div>
